import React, { useState } from "react";
import { useSelector } from "react-redux";
import AkkhorLayout from "../layout/akkhor";
import Axios from "axios";
import { useFormik } from "formik";
import Spinner from "../component/Spinner";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import * as Yup from "yup";

export default function ExportVanThu(props) {
    const { user } = useSelector((state) => state.auth);
    const [linkDownload,setLinkDownLoad] = useState(null);
    const formik = useFormik({
        initialValues: {month: new Date().getMonth, year: new Date().getFullYear},
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
           
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            let _url = URL_LIST_ALL + 'vanthu?export=true&limit=10000000'
            Axios.get(_url, user.config).then(async (res) => {
                console.log(res)
                setSubmitting(false);
                if (res.data.status === "success") {
                    resetForm();
                    // window.open(res.data.data, "_blank")
                    setLinkDownLoad(res.data.data)
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch((err) => console.log(err));
        },
    });

   

    return (
        <AkkhorLayout idrole="van-thu" >
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/van-thu">Danh sách văn thư</Link>
                    </li>
                    <li>Xuất văn thư</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Xuất danh sách văn thư</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 mg-t-8">
                                <div className="col-12"></div>
                                 {linkDownload && (
                                    <div className="my-3">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => {
                                                fetch(linkDownload)
                                                    .then((res) => res.blob())
                                                    .then((blob) => {
                                                        let url = window.URL.createObjectURL(blob);
                                                        url = url.replace(/^http:\/\//i, 'https://');
                                                        const a = document.createElement('a');
                                                        a.href = url;
                                                        a.download = 'vanthu'+(new Date())+".xlsx";
                                                        document.body.appendChild(a);
                                                        a.click();
                                                        a.remove();
                                                        window.URL.revokeObjectURL(url);
                                                    })
                                                    .catch((e) => {
                                                        console.log(e);
                                                        
                                                        alert("Không thể tải file. Vui lòng thử lại.");
                                                    });
                                            }}
                                        >
                                            Tải file Excel
                                        </button>
                                    </div>
                                )}
                                <div className="alert alert-primary" role="alert">
                                    <div className="mt-3">
                                        <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark mr-2">{formik.isSubmitting ? <Spinner /> : <>Xuất File</>}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
